import React from "react";
import { Link, useLocation } from "react-router-dom";
import { createPageUrl } from "@/utils";
import { logout } from "@/api/auth";
import { LogOut } from "lucide-react";

// Nav = konkrete Personen (Agenten), keine abstrakten Modi. KREIEREN bleibt,
// bis der Content-Agent einen Namen hat.
const MODES = [
  { label: "MORPHEUS", page: "Morpheus" },
  { label: "HERALD", page: "Promotion" },
  { label: "KREIEREN", page: "Kreieren" },
  { label: "KOBOLD", page: "Kobold" },
  { label: "BOOKER", page: "Booker" },
  { label: "SPIDER", page: "Verbinden" },
  { label: "EINSTEIN", page: "Bauen" },
];

export default function ModeHeader() {
  const { pathname } = useLocation();
  const active = (page) =>
    pathname.toLowerCase() === createPageUrl(page).toLowerCase() ||
    (page === "Morpheus" && pathname === "/");
  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-14 px-4 flex items-center justify-between border-b border-white/10 bg-[#0A0A10]/80 backdrop-blur-xl">
      <Link to={createPageUrl("Morpheus")} className="font-display text-lg font-semibold text-white tracking-tight shrink-0">MORPHEUS</Link>
      <nav className="flex items-center gap-1">
        {MODES.map((m) => (
          <Link key={m.page} to={createPageUrl(m.page)}
            className={`px-3 py-1.5 rounded-full text-xs font-mono-ui tracking-wide transition ${active(m.page) ? "bg-[rgba(var(--signal-rgb),0.15)] text-[var(--signal)]" : "text-gray-400 hover:text-white"}`}>
            {m.label}
          </Link>
        ))}
      </nav>
      <button onClick={logout} title="Abmelden" className="text-gray-400 hover:text-white p-2 rounded-lg shrink-0">
        <LogOut className="w-4 h-4" />
      </button>
    </header>
  );
}
